import Vue from 'vue'

export default {
  getChiefs ({ commit }, id) {
    return Vue.axios.get(`/about/departments`)
    .then(({ data }) => {
      commit('ADD_CHIEFS', data)
    })
  },
  updateChiefsOrder ({ commit }, chiefs) {
    commit('ADD_CHIEFS', chiefs)
    return Vue.axios.put(`/about/departments/chiefs-order`, { chiefs })
  },
  updateCheif ({ commit }, chief) {
    commit('UPDATE_CHIEF', chief)
  },
  saveChief ({ commit, dispatch }, chief) {
    let newPhoto
    if (chief.photo && chief.photo.base64photo) {
      newPhoto = chief.photo
      chief.photo = ''
    }
    return Vue.axios.put(`/about/departments/chiefs/${chief.id}`, { chief })
    .then(() => {
      if (newPhoto) {
        return dispatch('loadChiefPhoto', { formData: newPhoto.data, id: chief.id })
      }
    })
  },
  addChief ({ commit }, data) {
    commit('ADD_DEPARTMENT_CHIEF', data)
  },
  deleteChief ({ commit }, id) {
    return Vue.axios.delete(`/about/departments/chiefs/${id}`)
    .then(() => commit('DELETE_CHIEF', id))
  },
  loadChiefPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/departments/chiefs/${id}/change-photo`, formData)
    .then(({ data }) => { commit('UPDATE_CHIEF', data) })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/departments.js